var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.35 17.303a.4.4 0 0 1 0-.605l2.988-2.588a.4.4 0 0 1 .662.302v5.177a.4.4 0 0 1-.662.303l-2.989-2.589Z",
    fill: "#17181D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 11.5,
    stroke: "#17181D"
  })));
};
export { SvgHide as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjM0OTEgMTcuMzAzMUMxNS4xNjUgMTcuMTQzNiAxNS4xNjUgMTYuODU3OSAxNS4zNDkxIDE2LjY5ODRMMTguMzM4MSAxNC4xMDk4QzE4LjU5NzIgMTMuODg1NSAxOSAxNC4wNjk1IDE5IDE0LjQxMjJMMTkgMTkuNTg5M0MxOSAxOS45MzIgMTguNTk3MiAyMC4xMTYgMTguMzM4MSAxOS44OTE3TDE1LjM0OTEgMTcuMzAzMVoiIGZpbGw9IiMxNzE4MUQiLz4KPGNpcmNsZSBjeD0iMTciIGN5PSIxNyIgcj0iMTEuNSIgc3Ryb2tlPSIjMTcxODFEIi8+Cjwvc3ZnPgo=";